// extracted by mini-css-extract-plugin
export var clone = "_vf-2";
export var displayNone = "_vf-4";
export var expandableItem = "_vf-5";
export var expanded = "_vf-6";
export var folderItem = "_vf-7";
export var ghost = "_vf-1";
export var hidden = "_vf-3";
export var pipeContainer = "_vf-8";
export var wrapper = "_vf-0";